import React, { useState, useEffect, useRef } from "react";
import axios from "../../setting/axios";
import "./BackendStatusBanner.css";

const BackendStatusBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const lastStartTime = useRef(null);
  const isFirstCheck = useRef(true);

  // const checkServerHealth = async () => {
  //   try {
  //     const response = await axios.get("/backend/health", {
  //       timeout: 10000,
  //     });

  //      if (response.status === 200) {
  //       const serverStartTime = response.data.server_start_time;

  //       if (isFirstCheck.current) {
  //         lastStartTime.current = serverStartTime;
  //         isFirstCheck.current = false;
  //         return;
  //       }
  //       if (lastStartTime.current && lastStartTime.current !== serverStartTime) {
  //         setShowBanner(true);
  //         lastStartTime.current = serverStartTime;

  //         setTimeout(() => {
  //           window.location.reload();
  //         }, 3000);
  //       }
  //     }
  //   } catch (error) {
  //     console.log("Health check failed");
  //   }
  // };

  // useEffect(() => {
  //   checkServerHealth();

  //   const interval = setInterval(() => {
  //     checkServerHealth();
  //   }, 30000);

  //   return () => clearInterval(interval);
  // }, []);

  if (!showBanner) return null;


  return (
    <div className="backend-status-overlay">
      <div className="backend-status-card">
        <div className="status-icon">
          <div className="spinner-large"></div>
        </div>
        <h2>Server is Restarting...</h2>
        <p>Please wait while we reconnect</p>
        {/* <div className="retry-info">
          Attempt: <span>{retryCount}</span>
        </div> */}
        <div className="progress-bar">
          <div className="progress-fill"></div>
        </div>
      </div>
    </div>
  );
};

export default BackendStatusBanner;